import { createRouter, createWebHistory } from "vue-router";
import {
  checkRole,
  doesUserRoleHave,
  errorToast,
  getEntityQuery,
  lowerCase,
  subEntity,
  translateText,
  userInSession,
} from "@/core/helpers/utility";
import routesConfig from "@/core/helpers/RouteList/routes";
const routes = [
  //Authentication
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/Login",
    name: "login",
    component: () => import("@/views/Auth/Login.vue"),
  },

  {
    path: "/resolver-login",
    name: "resolver-login",
    component: () => import("@/views/Auth/resolverLogin.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/Auth/forgotPassword.vue"),
  },
  {
    path: "/Account/ResetPassword",
    name: "reset-password",
    component: () => import("@/views/Auth/resetPassword.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/Auth/contact.vue"),
  },

  {
    path: "/account/confirmEmail",
    name: "confirm-email",
    component: () => import("@/views/Auth/confirmEmail.vue"),
  },
  {
    path: "/call-back",
    name: "callback",
    component: () => import("@/views/Auth/callBack.vue"),
  },
  //Components
  {
    path: "/component",
    name: "component",
    component: () => import("@/views/componentView/componentView.vue"),
  },

  ////////////////// STATION LEVEL ROUTES

  /////////////// REPORTS

  //////////////// SALES REPORTS

  {
    path: "/station/sales-transactions",
    name: "station-sales-transactions",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/SalesTransactions/index.vue"),
  },

  {
    path: "/station/end-of-day-report",
    name: "station-end-of-day-report",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/EndOfDayReport.vue"),
  },

  {
    path: "/station/pump-variance",
    name: "station-pump-variance",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/PumpVariance.vue"),
  },

  {
    path: "/station/tank-variance",
    name: "station-tank-variance",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/TankVariance.vue"),
  },

  {
    path: "/station-pos-sales",
    name: "station-pos-sales",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/POSSales.vue"),
  },

  {
    path: "/branch-sufficiency-metrics",
    name: "branch-sufficiency-metrics",
    meta: {
      middleware: "auth",
    },

    component: () =>
      import(
        "@/views/Company/Reports/InventoryReports/SufficiencyMetrics/branchSufficiency.vue"
      ),
  },

  /////////////

  //////////////// CASH REPORTS

  {
    path: "/station/cashflow",
    name: "station-cashflow",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Branch/Reports/CashReports/Cashflow.vue"),
  },

  /////////////

  //////////////// INVENTORY REPORTS

  {
    path: "/station/sales-transactions",
    name: "station-sales-transactions",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/SalesTransactions/index.vue"),
  },

  /////////////

  /////////

  ///////////////

  //   Company Level
  //Dashboard
  {
    path: "/dashboard",
    name: "dashboard",

    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },

  // NNPC ROUTE

  {
    path: "/company-product-stock",
    name: "company-product-stock",

    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/ProductStock.vue"),
  },

  {
    path: "/company-product-inventory",
    name: "company-product-inventory",

    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/ProductInventory.vue"),
  },

  {
    path: "/inventory-supply/:branchId",
    name: "inventory-supply",

    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/InventorySupply.vue"),
  },

  {
    path: "/inventory-sales/:branchId",
    name: "inventory-sales",

    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/InventorySales.vue"),
  },

  /////

  {
    path: "/disconnected-pumps",
    name: "disconnected-pumps",

    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/DisconnectedPumps.vue"),
  },

  {
    path: "/offline-pumps",
    name: "offline-pumps",

    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/OfflinePumps.vue"),
  },

  {
    path: "/transaction-count",
    name: "transaction-count",

    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/TransactionCount.vue"),
  },

  //////////

  //Stations
  {
    path: "/stations",
    name: "stations",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/index.vue"),
  },
  {
    path: "/station-dashboard",
    name: "station-dashboard",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/StationDashboard.vue"),
  },
  {
    path: "/mail-recepient/:id",
    name: "mail-recepient",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MailRecepient.vue"),
  },
  {
    path: "/monthly-budget/:id",
    name: "monthly-budget",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MonthlyBudget.vue"),
  },
  {
    path: "/max-cash-amount/:id",
    name: "max-cash-amount",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MaxCashAmount.vue"),
  },
  {
    path: "/manage-target",
    name: "manage-target",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/ManageTarget/ManageTarget.vue"),
  },
  ///////////////// REPORTS

  // station sales
  {
    path: "/station-sales",
    name: "station-sales",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/StationSales.vue"),
  },

    {
    path: "/retainership-sales",
    name: "retainership-sales",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RetainershipSales/index.vue"),
  },

   {
    path: "/retainership-sales-details",
    name: "retainership-sales-details",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RetainershipSales/details.vue"),
  },

  {
    path: "/tank-variance",
    name: "tank-variance",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/TankVariance.vue"),
  },

  {
    path: "/pump-variance",
    name: "pump-variance",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/PumpVariance.vue"),
  },

  {
    path: "/remis-sales",
    name: "remis-sales",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/index.vue"),
  },

  {
    path: "/remis-sales-details",
    name: "remis-sales-details",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/Details.vue"),
  },
  {
    path: "/remis-company-wallet",
    name: "remis-company-wallet",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import(
        "@/views/Company/Reports/SalesReports/RemisSales/CompanyWallet.vue"
      ),
  },
  {
    path: "/remis-sales-wallet",
    name: "remis-sales-wallet",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/RemisWallet.vue"),
  },
  {
    path: "/pos-sales",
    name: "pos-sales",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/POSSales.vue"),
  },

  {
    path: "/cashflow",
    name: "cashflow",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Reports/CashReports/Cashflow.vue"),
  },

  {
    path: "/daily-branch-transactions",
    name: "daily-branch-transactions",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/CashReports/DailyBranchTranactions.vue"),
  },

  //inventory Report

  {
    path: "/product-discharged",
    name: "product-discharged",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import(
          "@/views/Company/Reports/InventoryReports/ProductDischarged/index.vue"
        ),
      branchComponent: () =>
        import(
          "@/views/Branch/Reports/InventoryReports/ProductsDischarged.vue"
        ),
    },
  },

  {
    path: "/tank-daily-report/:id",
    name: "tank-daily-report",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/TankManagement/dailyReport.vue"),
  },

  {
    path: "/check-calibration/:id",
    name: "check-calibration",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/TankManagement/checkCalibration.vue"),
  },

  {
    path: "/discharged-details/:id",
    name: "discharged-details",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import(
        "@/views/Company/Reports/InventoryReports/ProductDischarged/DischargeDetails.vue"
      ),
  },

  {
    path: "/stock-valuation",
    name: "stock-valuation",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/Reports/InventoryReports/StockValuation.vue"),
      branchComponent: () =>
        import("@/views/Branch/Reports/InventoryReports/StockValuation.vue"),
    },
  },
  {
    path: "/tank-report",
    name: "tank-report",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/InventoryReports/TankReport.vue"),
  },
  {
    path: "/inventory-report",
    name: "Inventory-report",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/InventoryReports/InventoryReport.vue"),
  },

  {
    path: "/product-stock",
    name: "product-stock",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/ProductStock.vue"),
  },

  {
    path: "/branch-reports",
    name: "branch-reports",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/BranchReports.vue"),
  },

  //
  //////////////

  {
    path: "/sufficiency-metrics",
    name: "sufficiency-metrics",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import(
        "@/views/Company/Reports/InventoryReports/SufficiencyMetrics/index.vue"
      ),
  },

  //Transactions
  {
    path: "/transactions",
    name: "transactions",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Transactions/index.vue"),
  },

  //Drystock
  {
    path: "/dry-stock-product",
    name: "dry-stock-product",
    meta: {
      middleware: "auth",
    },
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Product/index.vue"),
    },
  },
  {
    path: "/dry-stock-product/:id",
    name: "drystock-single-product",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Product/SingleProduct.vue"),
    },
  },
  {
    path: "/branch-product-stock",
    name: "dry-stock-stock",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import(
        "@/views/Company/DryStock/BranchProductStock/BranchProductStock.vue"
      ),
  },
  {
    path: "/branch-product-stock-sale/:id",
    name: "dry-stock-stock-sale",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/BranchProductStock/SalesDetails.vue"),
  },
  {
    path: "/branch-product-stock-supply/:id",
    name: "dry-stock-stock-supply",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/BranchProductStock/SupplyDetails.vue"),
  },

  {
    name: "dry-stock-supply",
    path: "/dry-stock-supply",
    meta: {
      middleware: "auth",
      isEntityDependent: true, // Flag to indicate that this route depends on entity
      companyComponent: () =>
        import("@/views/Company/DryStock/supply/supply.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Supply/supply.vue"),
    },
  },
  {
    name: "dry-stock-supply-details",
    path: "/dry-stock-supply-details/:id",
    meta: {
      middleware: "auth",
      isEntityDependent: true, // Flag to indicate that this route depends on entity
      companyComponent: () =>
        import("@/views/Company/DryStock/supply/supplyDetail.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Supply/supplyDetail.vue"),
    },
  },
  {
    path: "/dry-stock-product-cat",
    name: "dry-stock-product-cat",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/productCategory/productCategory.vue"),
    // meta: {
    //   middleware: "auth",
    //   isEntityDependent: true, // Flag to indicate that this route depends on entity
    //   companyComponent: () =>
    //     import("@/views/Company/DryStock/Supply/supplyDetail.vue"),
    //   branchComponent: () =>
    //     import("@/views/Branch/Drystock/Supply/supplyDetail.vue"),
    // },
  },
  {
    path: "/category-details/:id",
    name: "category-details",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/productCategory/details.vue"),
    // meta: {
    //   middleware: "auth",
    //   isEntityDependent: true, // Flag to indicate that this route depends on entity
    //   companyComponent: () =>
    //     import("@/views/Company/DryStock/Supply/supplyDetail.vue"),
    //   branchComponent: () =>
    //     import("@/views/Branch/Drystock/Supply/supplyDetail.vue"),
    // },
  },
  {
    name: "dry-stock-sales",
    path: "/dry-stock-sales",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Sales/sales.vue"),
      branchComponent: () => import("@/views/Branch/Drystock/Sales/sales.vue"),
    },
  },
  {
    name: "dry-stock-sales-details",
    path: "/dry-stock-sales-details/:id",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Sales/SalesDetails.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Sales/SalesDetails.vue"),
    },
  },

  //Region
  {
    path: "/region",
    name: "region",
    component: () => import("@/views/Company/Region/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  {
    path: "/region-stations",
    name: "region-stations",
    component: () => import("@/views/Company/Region/region-stations.vue"),
    meta: {
      middleware: "auth",
    },
  },
  //Pump management

  {
    path: "/pump-management",
    name: "pump-management",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      branchComponent: () => import("@/views/Company/PumpManagement/index.vue"),
    },
  },

  {
    path: "/pump-details/:pumpId",
    name: "pump-details",
    component: () =>
      import("@/views/Company/PumpManagement/PumpDetails/index.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Company/PumpManagement/PumpDetails/index.vue"),
    },
  },

  {
    path: "/manage-pump-lock",
    name: "manage-pump-lock",
    component: () =>
      import("@/views/Company/PumpManagement/ManagePumpLock/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // Price Management
  {
    path: "/price-log",
    name: "price-log",

    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/PriceManagement/PriceLog/PriceLog.vue"),
      branchComponent: () =>
        import("@/views/Branch/PriceManagement/PriceLog.vue"),
    },
  },

  {
    path: "/price-approval",
    name: "price-approval",
    component: () =>
      import("@/views/Company/PriceManagement/priceApproval/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  {
    path: "/manage-approval",
    name: "manage-approval",
    component: () =>
      import("@/views/Company/PriceManagement/ManageApproval/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  {
    path: "/price-approval-details",
    name: "price-approval-details",
    component: () =>
      import(
        "@/views/Company/PriceManagement/priceApproval/requestDetails.vue"
      ),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/pump-calibration",
    name: "pump-calibration",
    component: () =>
      import("@/views/Company/PriceManagement/Calibration/index.vue"),

    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/shutdown-pump",
    name: "shutdown-pump",
    component: () =>
      import("@/views/Company/PriceManagement/ShutdownPump/index.vue"),

    meta: {
      middleware: "auth",
    },
  },
  //staff management
  {
    path: "/staff-management",
    name: "staff-management",
    component: () => import("@/views/Company/StaffManagement/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/company-staff-list",
    name: "company-staff-list",
    component: () =>
      import("@/views/Company/StaffManagement/CompanyStaff/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/leave-management",
    name: "leave-management",
    component: () =>
      import("@/views/Company/StaffManagement/LeaveManagement/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/salary-management",
    name: "salary-management",
    component: () =>
      import("@/views/Company/StaffManagement/SalaryManagement/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  // {
  //   path: "/salary-details",
  //   name: "salary-details",
  //   component: () =>
  //     import(
  //       "@/views/Company/StaffManagement/SalaryManagement/SalaryDetails.vue"
  //     ),
  //   meta: {
  //     middleware: "auth",
  //   },
  // },
  // payroll
  {
    path: "/payroll",
    name: "payroll",
    component: () =>
      import("@/views/Company/StaffManagement/Payroll/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  //performance evaluation
  {
    path: "/performance-evaluation",
    name: "performance-evaluation",
    component: () =>
      import("@/views/Company/StaffManagement/PerformanceEval/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  //staff comparison
  {
    path: "/staff-comparison",
    name: "staff-comparison",
    component: () =>
      import("@/views/Company/StaffManagement/PerformanceComparison/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // Groups

  {
    path: "/leave-details/:staffId",
    name: "leave-details",
    component: () =>
      import("@/views/Company/StaffManagement/Drawers/LeaveDetails.vue"),
    meta: {
      middleware: "auth",
    },
  },
  // Groups

  {
    path: "/groups",
    name: "groups",
    component: () => import("@/views/Company/Groups/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/group/:id",
    name: "single-group",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/SingleGroup.vue"),
  },
  {
    path: "/group-detail/:id",
    name: "group-detail",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/Details/index.vue"),
  },
  {
    path: "/group-users/:id",
    name: "group-users",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/Users/index.vue"),
  },

  // BANKS
  {
    path: "/bank-accounts",
    name: "bank-accounts",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/Bank/BankAccounts/index.vue"),
  },

  {
    path: "/bank-account-requests",
    name: "bank-account-requests",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Bank/BankAccountRequests/index.vue"),
  },

  //BANK DEPOSIT
  {
    path: "/bank-deposit",
    name: "bank-deposit",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/BankDeposit/index.vue"),
  },
  {
    path: "/branch-bank-deposit",
    name: "bank-deposit-detail",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/BankDeposit/details.vue"),
  },

  // REMIS
  {
    path: "/remis/loyalty",
    name: "remis-loyalty",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Loyalty/index.vue"),
  },
  {
    path: "/remis/loyalty-detail/:loyaltyId",
    name: "loyalty-details",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Loyalty/LoyaltyDetails.vue"),
  },
  {
    path: "/remis/pos",
    name: "remis-pos",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/POS/index.vue"),
  },
  {
    path: "/remis/pos-transaction/:terminalId",
    name: "remis-pos-transaction",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Remis/POS/POSTransactionDetails.vue"),
  },
  {
    path: "/remis/fueling",
    name: "remis-fueling",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Fueling/index.vue"),
  },
  {
    path: "/remis/fueling-details",
    name: "remis-fueling-details",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Fueling/details.vue"),
  },
  {
    path: "/remis/retainership",
    name: "remis-retainership",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Retainership/index.vue"),
  },
  {
    path: "/remis/wallet-topup-requests",
    name: "wallet-topup-requests",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Wallet-topup/index.vue"),
  },
  {
    path: "/remis/card-management",
    name: "remis-card-management",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/CardManagement/index.vue"),
  },
  {
    path: "/remis/retainership/transaction-history",
    name: "remis-retainership-transaction-history",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Remis/Retainership/TransactionHistory/index.vue"),
  },
  {
    path: "/remis/wallet",
    name: "remis-wallet",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Wallet/index.vue"),
  },

  /////////////////// STATION RENTS

  {
    path: "/rent-records",
    name: "rent-records",
    meta: {
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/RentRecords/index.vue"),
  },

  {
    path: "/properties",
    name: "properties",
    component: () =>
      import("@/views/Company/StationRents/Properties/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/property-details/:id",
    name: "property-details",
    component: () =>
      import("@/views/Company/StationRents/Properties/PropertyDetails.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/occupants",
    name: "Occupants",
    component: () => import("@/views/Company/StationRents/Occupants/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/occupant-details/:id",
    name: "occupant-details",
    component: () =>
      import("@/views/Company/StationRents/Occupants/OccupantDetails.vue"),
    meta: {
      middleware: "auth",
    },
  },
  //Expense management
  {
    path: "/Expense-management",
    name: "Expense Management",
    meta: {
      middleware: "auth",
      isEntityDependent: true, // Flag to indicate that this route depends on entity
      companyComponent: () => import("@/views/Company/Expense/index.vue"),
      branchComponent: () =>
        import("@/views/Company/Expense/ExpenseDetails.vue"),
    },
  },
  {
    path: "/Expense-category",
    name: "Expense Category",
    meta: {
      middleware: "auth",
      isEntityDependent: true, // Flag to indicate that this route depends on entity
      companyComponent: () =>
        import("@/views/Company/Expense/ExpenseCategory.vue"),
      branchComponent: () =>
        import("@/views/Company/Expense/ExpenseCategory.vue"),
    },
  },
  {
    path: "/Expense-details/:id",
    name: "Expense Details",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Expense/ExpenseDetails.vue"),
  },
  ////////////////////

  /////////////////Region Level
  //Dashboard
  {
    path: "/region/dashboard",
    name: "region-dashboard",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Maintenance/index.vue"),
      branchComponent: () => import("@/views/Common/Maintenance/index.vue"),
    },
  },
  {
    name: "maintenance-details",
    path: "/maintenance/:id",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Maintenance/details.vue"),
      branchComponent: () => import("@/views/Common/Maintenance/details.vue"),
    },
  },

  ////////////////// Station Level
  //Dashboard
  {
    path: "/station/dashboard",
    name: "station-dashboard",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },
  //Tank Management
  {
    path: "/tank-management",
    name: "tank-management",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      branchComponent: () => import("@/views/Company/TankManagement/index.vue"),
    },
  },

  {
    path: "/tank-management/:id",
    name: "tank-details",
    component: () => import("@/views/Company/TankManagement/details.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Company/TankManagement/details.vue"),
    },
  },

  //MANUAL RECORDS
  {
    path: "/manual-records",
    name: "manual-records",
    component: () =>
      import("@/views/Common/Manualrecords/ManualRecord/index.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Common/Manualrecords/ManualRecord/index.vue"),
    },
  },
  {
    path: "/rejected-records",
    name: "rejected-records",
    component: () =>
      import("@/views/Common/Manualrecords/RejectedRecords/index.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Common/Manualrecords/RejectedRecords/index.vue"),
    },
  },
  {
    path: "/record-dippings",
    name: "record-dippings",
    component: () =>
      import("@/views/Common/Manualrecords/RecordDipping/index.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Common/Manualrecords/RecordDipping/index.vue"),
    },
  },
  {
    path: "/manual-record-list",
    name: "manual-record-list",
    component: () =>
      import("@/views/Common/Manualrecords/RecordList/index.vue"),
    meta: {
      middleware: "auth",
      // isEntityDependent: true,
      // branchComponent: () =>
      //   import("@/views/Common/Manualrecords/RecordList/index.vue"),
    },
  },

  // {
  // 	path: "/resolved-totalizer",
  // 	name: "resolved-totalizer",
  // 	component: () =>
  // 		import("@/views/Company/ManualRecords/ResolvedTotalizer/index.vue"),
  // 	meta: {
  // 		middleware: "auth",
  // 	},
  // },

  /////////////////Region Level
  //Dashboard
  {
    path: "/region/dashboard",
    name: "region-dashboard",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Maintenance/index.vue"),
      branchComponent: () => import("@/views/Common/Maintenance/index.vue"),
    },
  },
  {
    name: "maintenance-details",
    path: "/maintenance/:id",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Maintenance/details.vue"),
      branchComponent: () => import("@/views/Common/Maintenance/details.vue"),
    },
  },
  {
    name: "support",
    path: "/support",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Support/index.vue"),
      branchComponent: () => import("@/views/Common/Support/index.vue"),
    },
  },
  {
    name: "services",
    path: "/services",
    meta: {
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Company/Services/index.vue"),
      branchComponent: () => import("@/views/Branch/Services/index.vue"),
    },
  },
  {
    name: "services-transactions",
    path: "/services-transactions",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Services/manageTransactions.vue"),
  },
  {
    name: "services-transaction",
    path: "/services-transaction/:id",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Company/Services/serviceTransactions.vue"),
  },
  {
    name: "services-manage-transactions",
    path: "/services-manage-transactions",
    meta: {
      middleware: "auth",
    },
    component: () => import("@/views/Branch/Services/manageTransactions.vue"),
  },

  // User Management
  {
    path: "/user-management",
    name: "user-management",
    component: () => import("@/views/Common/UserManagement/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/user-management/:id",
    name: "single-user",
    component: () => import("@/views/Common/UserManagement/SingleUser.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // INVOICE
  {
    path: "/invoice",
    name: "invoice",
    component: () => import("@/views/Common/Invoice/index.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/invoice-details/:id",
    name: "invoice-details",
    component: () => import("@/views/Common/Invoice/details.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/invoice-payment-history/:id",
    name: "invoice-payment-history",
    component: () => import("@/views/Common/Invoice/paymentHistory.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // MAKE PAYMENT
  {
    path: "/stripe-payment",
    name: "makeStripePayment",
    component: () =>
      import("@/views/Common/WalletAndPayments/MakeStripePayment.vue"),
    meta: {
      middleware: "auth",
    },
  },
  {
    path: "/paystack-payment",
    name: "makePaystackPayment",
    component: () =>
      import("@/views/Common/WalletAndPayments/MakePaystackPayment.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // PUMP CODE
  {
    path: "/pump-code",
    name: "pumpCode",
    component: () => import("@/views/Common/PumpCode/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  // ALERT AND ALARM
  {
    path: "/alert-alarm",
    name: "alertAlarm",
    component: () => import("@/views/Company/AlertAlarm/index.vue"),
    meta: {
      middleware: "auth",
    },
  },

  //support admin
  {
    path: "/company-list",
    name: "company-list",
    component: () => import("@/views/Support/Companies/index.vue"),
    meta: {
      middleware: "auth",
      isSupportAdmin: true,
    },
  },
  {
    path: "/company-support-tickets",
    name: "company-support-tickets",
    component: () => import("@/views/Support/Support/index.vue"),
    meta: {
      middleware: "auth",
      isSupportAdmin: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const preservedQueryParams = ["branchId", "regionId", "groupId", "companyId"];
const noQueryRoutes = ["login", "company-list"];

//route guards
router.afterEach((to)=>{
if (window.gtag) {
    window.gtag('config', 'G-YR0P2LW6DX', {
      page_path: to.fullPath,
    });
  }
})
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("auth-user");

  // 🚨 ROUTE GUARD FOR ROUTES THAT CONSIDER USER ROLES 🚨
  if (isAuthenticated) {
    const userRoles = JSON.parse(localStorage.getItem("auth-user")).role || [];
    let shouldProceed = true;
    let redirectPath = null;

    // Find the matching route from your configuration
    const findRouteConfig = (path, configRoutes) => {
      for (const route of configRoutes) {
        // Check main route
        if (route.path === path || route.name?.includes(to.name)) {
          return route;
        }
        // Check nested routes
        if (route.children) {
          const childMatch = route.children.find(
            (child) => child.path === path || child.name === to.name
          );
          if (childMatch) {
            return { ...childMatch, parentRoles: route.roles };
          }
        }
      }
      return null;
    };

    const routeConfig =
      findRouteConfig(to.path, routesConfig.routes) ||
      findRouteConfig(to.path, routesConfig.otherRoutes);

    // Support admin bypass (can access all routes)
    if (!userRoles.includes("SupportAdmin")) {
      // If route requires specific roles
      if (routeConfig?.roles || routeConfig?.parentRoles) {
        // Combine route roles and parent route roles if they exist
        const requiredRoles = [
          ...(routeConfig.roles || []),
          ...(routeConfig.parentRoles || []),
        ];

        // Check if user has at least one required role
        const hasAccess =
          requiredRoles.length === 0 ||
          requiredRoles.some((role) => userRoles.includes(role));

        if (!hasAccess) {
          shouldProceed = false;
          redirectPath = from.name ? from : { name: "dashboard" };
          setTimeout(() => {
            errorToast(translateText("common.noPageAccess"));
          }, 3000);
        }
      }
    }

    if (!shouldProceed) {
      return next(redirectPath);
    }
  }

  // 🚨 If route requires authentication and user is not authenticated
  if (to.meta.middleware === "auth" && !isAuthenticated) {
    return next("/login"); // Redirect to login page
  }

  // 🚨 If user is authenticated but trying to access a non-auth route
  if (
    to.meta.middleware !== "auth" &&
    from.meta?.middleware === "auth" &&
    isAuthenticated
  ) {
    return next(false); // prevent from accessing the route
  }
  if (to.meta.middleware !== "auth" && isAuthenticated) {
    return next("/dashboard"); // Prevent or redirect to dashboard
  }

  // 🚨 ROUTE GUARD FOR UNKNOWN ROUTES
  const matchedRouteExists = to.matched.length > 0;
  if (!isAuthenticated && !matchedRouteExists) {
    return next("/login");
  }

  // 🚨 ROUTE GUARD FOR ROUTES, QUERY AND PARAMS
  let updatedQuery;

  if (noQueryRoutes.includes(lowerCase(to.name))) {
    updatedQuery = {}; // Reset query params for login page
  } else {
    if (to.query.new) {
      updatedQuery = { ...to.query };
    } else {
      updatedQuery = { ...to.query };

      preservedQueryParams.forEach((param) => {
        if (from.query[param]) {
          updatedQuery[param] = from.query[param];
        }
      });
    }
  }

  const { entityType } = getEntityQuery(updatedQuery);

  // Handle entity-dependent components
  to.matched.forEach((routeRecord) => {
    if (routeRecord.meta.isEntityDependent) {
      if (!routeRecord.components) {
        routeRecord.components = {}; // Initialize components if undefined
      }

      // Safely assign default component based on entity
      if (entityType?.toLowerCase() === "branch") {
        routeRecord.components.default = routeRecord.meta.branchComponent;
      } else {
        routeRecord.components.default = routeRecord.meta.companyComponent;
      }
    }
  });

  // If query params have been updated, navigate to the new query path
  if (JSON.stringify(to.query) !== JSON.stringify(updatedQuery)) {
    return next({
      path: to.path,
      query: updatedQuery,
      // replace: true,
    });
  }

  // 🚨 Redirect support admin to the company list whenever they visit a page without a query parameter

  if (
    isAuthenticated &&
    doesUserRoleHave("SupportAdmin") &&
    Object.keys(updatedQuery)?.length < 1 &&
    to.name !== "company-list" &&
    to.name !== "company-support-tickets"
  ) {
    return next({
      path: "/company-list",
      query: updatedQuery,
    });
  }

  // REVISIT COMPANY STAFF
  // console.log(to.query, from.query, "to.query");
  if (to.name === "company-staff-list" && to.query?.branchId) {
    // console.log("Removing branchId to prevent loop...");

    const { branchId, ...queryWithoutBranchId } = to.query;
    // console.log(queryWithoutBranchId, "query");
    to.query = queryWithoutBranchId;

    return next();
  }

  //

  // Scroll to the top on route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  // If no updates are required, continue with navigation
  return next();
});

export default router;
